import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
import api from "./api.js";
import createHistory from "history/createBrowserHistory";

export default function callAssignedJobs(component, status) {
  console.log("statusstatus", status);
  if (status === "delivered") {
    component.props.completedJobsAction(null);
  }
  const rider_id = localStorage.getItem("rider_id");
  // const vehicle_id=localStorage.getItem('vehicle_id');
  const Authorization = "bearer " + localStorage.getItem("token");
  fetch(`${API_URL}rest/V1/rider/getJobList`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({
      searchCriteria: {
        rider_id: rider_id,
        status: status,
      },
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (data) {
      console.log("datadata", data, status);

      if (status === "in-transit") {
        // data[0] && data[0].status == "success"
        //   ? api.callShippingJobs(component, data[0].data[0].job_id)
        //   : component.props.actionProcessingJobs("failure");

        if (data[0] && data[0].status == "success") {
          component.props.actionIntransitJob(data[0] && data[0].data);
          api.callShippingJobs(component, data[0].data[0].job_id);
        } else {
          component.props.actionProcessingJobs("failure");
          component.props.actionIntransitJob("failure");
          console.log("windowlocationpathname", window.location.pathname);
          if (window.location.pathname == "/intransit") {
            const history = createHistory({ forceRefresh: true });
            console.log("gunaHist", history);
            history.push("/");
          }
        }

        return;
      } else if (status === "assigned") {
        data[0] && data[0].data
          ? component.props.assignedJobsAction(data[0] && data[0].data)
          : component.props.assignedJobsAction("failure");
        return;
      } else if (status === "delivered") {
        data[0] && data[0].data
          ? component.props.completedJobsAction(data[0] && data[0].data)
          : component.props.completedJobsAction("failure");
      }

      // component &&
      //   component.prop &&
      //   component.prop.assignedJobsAction(data[0].data);

      // if (data[0].status === "success" && component.props) {
      //   if (status === "processing") {
      //     api.callShippingJobs(component, data[0].data.trips[0].trip_id);
      //     return;
      //   }
      //   component.props.assignedJobsAction(data[0].data);
      // } else if (data[0].status === "failure") {
      //   status === "pending"
      //     ? component.props.assignedJobsAction("failure")
      //     : component.props.actionProcessingJobs("failure");
      // }
    });
}



// WEBPACK FOOTER //
// ./src/utility/api/callAssignedJobs.js